import { render, staticRenderFns } from "./RequireListTwo.vue?vue&type=template&id=9db6098e"
import script from "./RequireListTwo.vue?vue&type=script&lang=js"
export * from "./RequireListTwo.vue?vue&type=script&lang=js"
import style0 from "./RequireListTwo.vue?vue&type=style&index=0&id=9db6098e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports